// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"217":"ffd2d415","374":"6aedfc6a"}[chunkId] + ".chunk.js";
};